document.addEventListener('DOMContentLoaded', function() {
    const navbar = document.querySelector('.navbar-background-bar');
    const heroSection = document.querySelector('main > .collection-hero, main > .carousel'); // Adjust selector based on your hero/slider class
    let lastScrollTop = 0;
    let heroHeight = 0;
    let headerHeight = 0;
    let isMobile = window.innerWidth <= 768;

    if (!navbar) return; // Exit if navbar not found

    if (heroSection) {
        heroHeight = heroSection.offsetHeight;
    }

    if (navbar) {
        headerHeight = navbar.offsetHeight;
    }

    // Function to check if device is mobile
    function checkMobile() {
        isMobile = window.innerWidth <= 768;
    }

    // Function to handle scroll event
    function handleScroll() {
        // Get current scroll position
        const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        
        // Add the transparent class if we're at the top
        if (currentScrollTop === 0) {
            navbar.classList.add('navbar-transparent');
            navbar.classList.remove('navbar-hidden');
            return;
        } else {
            navbar.classList.remove('navbar-transparent');
        }
        
        // Handle the hiding of navbar based on scroll direction
        if (currentScrollTop > lastScrollTop && currentScrollTop > headerHeight) {
            // Scrolling down, hide navbar
            navbar.classList.add('navbar-hidden');
        } else {
            // Scrolling up, show navbar
            navbar.classList.remove('navbar-hidden');
        }
        
        // Update the last scroll position
        lastScrollTop = currentScrollTop;
    }

    // Debounce function to limit scroll event frequency
    function debounce(func, wait) {
        let timeout;
        return function executedFunction(...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }

    // Add debounced scroll event listener
    window.addEventListener('scroll', debounce(handleScroll, 15)); // Reduced wait time for more responsive hiding
    
    // Listen for window resize to update mobile status
    window.addEventListener('resize', debounce(checkMobile, 100));

    // Initial check in case the page loads scrolled down
    checkMobile();
    handleScroll(); 
}); 